var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import Icons from '../../../icons';
import { FlexColumnContainer } from '../../../styles/generalStyles';
import { TitleForm, MainTextStyle } from '../../../styles/variables/text.styles';
import { Button } from '../button/button.styles';
import { LangHelper } from '../lang/helper';
import LangMessage from '../lang/message';
var ModalWindowWrapperStyles = styled.dialog(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0px;\n  left: 0px;\n  z-index: 9999;\n  background: rgba(28, 38, 57, 0.5);\n  overflow: hidden; \n"], ["\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0px;\n  left: 0px;\n  z-index: 9999;\n  background: rgba(28, 38, 57, 0.5);\n  overflow: hidden; \n"])));
var ModalWindowContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n  max-width: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  background: white;\n"], ["\n  position: relative;\n  width: ", ";\n  height: ", ";\n  max-width: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  background: white;\n"])), function (_a) {
    var $width = _a.$width;
    return $width;
}, function (_a) {
    var $height = _a.$height;
    return $height;
}, function (_a) {
    var $maxWidth = _a.$maxWidth;
    return $maxWidth;
});
export var CloseIcon = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  top: -1px;\n  right: -2px;\n  z-index: 1001;\n"], ["\n  cursor: pointer;\n  position: absolute;\n  top: -1px;\n  right: -2px;\n  z-index: 1001;\n"])));
export var ModalWindowWrapper = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, widthContent = _a.widthContent, maxWidthContent = _a.maxWidthContent, heightContent = _a.heightContent, children = _a.children, titleMsgKey = _a.titleMsgKey, mainMsgKeys = _a.mainMsgKeys, continueBtnMsgKey = _a.continueBtnMsgKey, lang = _a.lang;
    var modalContentRef = useRef(null);
    useEffect(function () {
        function handleClickOutside(event) {
            var target = event.target;
            if (modalContentRef.current &&
                target &&
                !modalContentRef.current.contains(target) &&
                !target.closest('.ModalContent')) {
                onClose && onClose();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [modalContentRef, onClose]);
    var CommonModalContent = function (_a) {
        var titleMsgKey = _a.titleMsgKey, mainMsgKeys = _a.mainMsgKeys, continueBtnMsgKey = _a.continueBtnMsgKey;
        return (_jsxs(FlexColumnContainer, __assign({ style: { alignItems: 'center', marginTop: "20px" } }, { children: [_jsx(TitleForm, { children: _jsx(LangMessage, { msgKey: titleMsgKey }) }), _jsx(MainTextStyle, { "$paddingTop": '20px', "$paddingBottom": '40px', width: '80%', dangerouslySetInnerHTML: { __html: LangHelper.getLangMessageValue(mainMsgKeys, lang) } }), _jsx("div", __assign({ style: { marginBottom: '40px', } }, { children: _jsx(Button, __assign({ "$size": 'medium', "$bgColour": 'blue', onClick: onClose }, { children: _jsx(LangMessage, { msgKey: continueBtnMsgKey }) })) }))] })));
    };
    return (_jsx(_Fragment, { children: isOpen && (_jsx(ModalWindowWrapperStyles, __assign({ open: isOpen }, { children: _jsxs(ModalWindowContent, __assign({ "$width": widthContent, "$maxWidth": maxWidthContent, "$height": heightContent, ref: modalContentRef, className: "ModalContent" }, { children: [_jsx(CloseIcon, { src: Icons.closeIcon, alt: 'close icon', onClick: onClose }), titleMsgKey && mainMsgKeys && continueBtnMsgKey ?
                        _jsx(CommonModalContent, { titleMsgKey: titleMsgKey, mainMsgKeys: mainMsgKeys, continueBtnMsgKey: continueBtnMsgKey })
                        : children] })) }))) }));
};
var templateObject_1, templateObject_2, templateObject_3;
